import type { Dishes, DeleteParams } from 'app/dataTypes/dishes'

import type { Request } from '../../index'


type ParamsApi = {
  item_id: Array<number>
}

type ResultApi = 'success'

export const convertParams = ({ itemIds }: DeleteParams): [ParamsApi, null] => {
  return [{ item_id: itemIds.map(val => parseInt(val, 10)) }, null]
}

export const convertResult = (data: ResultApi): 'success' => {
  return data
}

export const DELETE_FOOD_ITEMS: Request<DeleteParams, Dishes, void> = [
  'food/items',
  'delete',
  ['data', 'result'],
]
